<div class="modalContainer">
  <div class="modal-header">
    <img src="../../../../../assets/gif/finzy-flex/switch-on.svg" alt="switch on image" class="modal-image"/>
    <div class="modal-title">You Can Now Invest Automatically</div>
    <div class="modal-sub-title">Switch on <span class="modal-sub-title-bold">Swift</span> to enable auto investment</div>
  </div>

  <div class="modal-body">
    <span>Swift is a convenient investment option allowing you to automatically invest your wallet funds into the loan(s) without any intervention from your end.</span>
  </div>

  <div class="modal-footer">
    <button type="button" mat-stroked-button class="primary no-text-transform" [mat-dialog-close]="false">Later</button>

    <button type="button" mat-flat-button class="primary no-text-transform continue-button" [mat-dialog-close]="true"
      cdkFocusInitial>Enable</button>
  </div>
</div>
